import type { Environment } from '@seddi/scene';
import {
  EquirectangularReflectionMapping,
  type LoadingManager,
  type PMREMGenerator,
  type WebGLRenderer,
} from '@seddi/three';
import type { EnvironmentGfx } from './environmentTypes';
import { load as loadTexture } from './textureLoader';

/**
 * Load environment.
 * @param desc - Descriptor.
 * @param manager - Loading manager.
 * @param renderer - WebGL renderer.
 * @param generator - PMREM generator.
 */
export const load = async (
  desc: Environment,
  manager: LoadingManager,
  renderer: WebGLRenderer,
  generator: PMREMGenerator,
): Promise<EnvironmentGfx> => {
  const { exposure, rotation, texture } = desc;

  // Load equirectangular texture.
  const equirectangularTexture = await loadTexture(texture, manager, renderer);
  equirectangularTexture.mapping = EquirectangularReflectionMapping;

  // Generate prefiltered, mipmapped, radiance texture.
  const radianceMap = generator.fromEquirectangular(equirectangularTexture).texture;

  return { exposure, id: desc.id, isEnvironment: true, rotation, texture: radianceMap };
};
